import alasql from "alasql";
import moment from "moment";
import Calc from "./calculate.helper";

const { $ } = window;

const Homechart = {
  colors: [
    "#3c4694",
    "#81efde",
    "#8DCEEF",
    "#000099",
    "#8080FF",
    "#0000ff",
    "#D2D7D3",
    "#ADD8E6",
    "#43559C",
    "#6774A9",
    "#7D849E",
    "#7E7EE6",
    "#6F6F73",
    "#5A5AB0",
    "#8989FA",
    "#C4C4F2",
    "#4183D7",
    "#4183D7",
    "#59ABE3",
    "#81CFE0",
    "#52B3D9",
    "#C5EFF7",
    "#22A7F0",
    "#3498DB",
    "#2C3E50",
    "#336E7B",
    "#6BB9F0",
    "#1E8BC3",
    "#34495E",
    "#67809F",
    "#89C4F3",
    "#67809F",
    "#5C97BF",
    "#E4F1FE",
  ],

  getPortfolioInfo: (portfolio_vami = [], benchmark_vami = []) => {
    let output = {};

    if (portfolio_vami.length && benchmark_vami.length) {
      let port_min_dt = portfolio_vami[0].dt;
      let port_max_dt = portfolio_vami[portfolio_vami.length - 1].dt;
      let fund_name = portfolio_vami[0].scenario_name;

      let benchmark_name = benchmark_vami[0].benchmark_name;
      let bm_min_dt = benchmark_vami[0].dt;
      let bm_max_dt = benchmark_vami[benchmark_vami.length - 1].dt;

      output = {
        port_min_dt: port_min_dt,
        port_max_dt: port_max_dt,
        bm_min_dt: bm_min_dt,
        bm_max_dt: bm_max_dt,
        fund_name: fund_name,
        benchmark_name: benchmark_name,
      };
    }

    return output;
  },

  renderPieChart: (
    portfolio_vami = [],
    benchmark_vami = [],
    portfolio_metrics = []
  ) => {
    let output = [];

    if (portfolio_vami.length && benchmark_vami.length) {
      let last_vami1 = portfolio_vami[portfolio_vami.length - 1];
      let fund_val = parseFloat(last_vami1.vami);
      let fund_name = portfolio_vami[0].scenario_name;
      fund_val = parseFloat(fund_val / 100).toFixed(2);

      let benchmark_name = benchmark_vami[0].benchmark_name;
      let last_vami = benchmark_vami[benchmark_vami.length - 1];
      let benchmark_val = parseFloat(last_vami.vami);
      benchmark_val = parseFloat(benchmark_val / 100).toFixed(2);

      output.push(
        {
          name: fund_name,
          value: fund_val + "%",
          percent: (parseFloat(fund_val) * 100) / 200,
        },
        {
          name: "BENCHMARK TOTAL RETURN",
          value: benchmark_val + "%",
          percent: (parseFloat(benchmark_val) * 100) / 200,
        }
      );
    }

    for (let i in portfolio_metrics[0]) {
      let line = portfolio_metrics[0][i];
      switch (i) {
        case "fund_annualized_vol":
          output.push({
            name: "Anualized Vol",
            value: line + "%",
            percent: (parseFloat(line) * 100) / 20,
          });
          break;
        case "fund_annualized_return":
          output.push({
            name: "Annualized Return",
            value: line + "%",
            percent: (parseFloat(line) * 100) / 20,
          });
          break;
      }
    }

    return output;
  },

  renderMainChart: (selector, vamix) => {
    let scnNAME = [];
    let scnNAMEV = [];
    let seriesOptions = [];
    let selectedScn = [];
    let datax = [];

    for (let i in vamix) {
      let val = vamix[i];

      if (scnNAME.indexOf(val.scenario_id) === -1) {
        if (selectedScn.length > 0) {
          if (selectedScn.indexOf(val.scenario_id) !== -1) {
            scnNAME.push(val.scenario_id);
            let sdata = Calc.getSCNData(val.scenario_id, vamix);
            seriesOptions.push({
              name: val.scenario_name || val.benchmark_name,
              data: sdata,
            });
          }
        } else {
          scnNAME.push(val.scenario_id);
          let sdata = Calc.getSCNData(val.scenario_id, vamix);
          seriesOptions.push({
            name: val.scenario_name || val.benchmark_name,
            data: sdata,
          });
        }
      }
    }

    setTimeout(() => {
      $(selector).highcharts("StockChart", {
        colors: ["#434348", "#7cb5ec"],
        title: {
          text: "",
        },
        legend: {
          enabled: true,
          symbolHeight: 100,
        },
        series: seriesOptions,
      });
    }, 0);
  },

  renderFBCChart(selector, metrics) {
    var month = [];
    var fund = [];
    var fund_vol = [];
    var bm = [];
    var bm_vol = [];

    for (let i in metrics) {
      let v = metrics[i];
      month.push("Scenario" + v.scenario_id);
      fund.push(parseFloat(v.fund_annualized_return));
      fund.push(parseFloat(v.fund_annualized_vol));
      bm.push(parseFloat(v.bm_annualized_return));
      bm.push(parseFloat(v.bm_annualized_vol));
    }

    setTimeout(() => {
      $(selector).highcharts({
        colors: ["#434348", "#7cb5ec"],
        chart: {
          type: "column",
        },
        title: {
          text: "Fund and Benchmark Comparison",
        },

        xAxis: {
          categories: ["Return", "Volatility"],
        },

        yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
            text: "Return/Vol(%)",
          },
        },

        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.x +
              "</b><br/>" +
              this.series.name +
              ": " +
              this.y +
              "%<br/>"
            );
          },
        },

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        legend: {
          enabled: true,
          labelFormatter: function () {
            var words = this.name.split(/[\s]+/);
            var numWordsPerLine = 5;
            var str = [];
            for (var word in words) {
              if (word > 0 && word % numWordsPerLine === 0) str.push("<br>");
              str.push(words[word]);
            }
            return str.join(" ");
          },
        },
        series: [
          {
            name: "Fund",
            data: fund,
          },
          {
            name: "Benchmark",
            data: bm,
          },
        ],
      });
    });
  },

  renderAssetStyleStockChart(
    assetSelector,
    styleSelector,
    assetPieSelector,
    stylePieSelector,
    dat
  ) {
    let dates = [];
    let styles = [];
    let ASTC = [];

    var fund_name = "";
    $.each(dat.getPortfolioVami, function (key, val) {
      fund_name = val.scenario_name;
      return false;
    });

    var bm_name = "";
    $.each(dat.getBenchmarkVami, function (key, val) {
      bm_name = val.benchmark_name;
      return false;
    });

    var arc_name = "";
    $.each(dat.getARCVami, function (key, val) {
      arc_name = val.benchmark_name;
      return false;
    });

    /***BAR CHART****/

    var scn_port = dat.getPortfolioData;

    $.each(scn_port, function (k, v) {
      if (dates.indexOf(v.dt) == -1) {
        dates.push(v.dt);
      }

      if (styles.indexOf(v.style) == -1) {
        styles.push(v.style);
      }

      if (ASTC.indexOf(v.fund_asset_class_focus) == -1) {
        ASTC.push(v.fund_asset_class_focus);
      }
    });

    var seriesOptions = [];
    $.each(styles, function (k, v) {
      var sdata = Calc.getDataForstac(dates, v, scn_port);
      seriesOptions.push({
        name: v,
        data: sdata,
      });
    });

    var seriesOptionsA = [];
    $.each(ASTC, function (k, v) {
      var sdata = Calc.getDataForstacA(dates, v, scn_port);
      seriesOptionsA.push({
        name: v,
        data: sdata,
      });
    });

    setTimeout(() => {
      $(styleSelector).highcharts("StockChart", {
        chart: {
          type: "area",
        },
        rangeSelector: {
          selected: 12,
        },
        colors: Homechart.colors,
        yAxis: {
          title: {
            text: "Total %",
          },
          labels: {
            align: "left",
            x: 15,
          },
        },
        tooltip: {
          formatter: function () {
            //console.log("total2"+this.points);
            var d = new Date(this.x);
            var s = d.toDateString() + "<br>";

            $.each(this.points, function (i, point) {
              s += "<br>" + point.series.name + ": " + point.y + "%" + "</br>";
            });
            return s;
          },
        },

        exporting: {
          enabled: false,
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          area: {
            stacking: "percent",
            lineColor: "#ffffff",
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: "#ffffff",
            },
          },
        },
        series: seriesOptions,
      });

      $(assetSelector).highcharts("StockChart", {
        chart: {
          type: "area",
        },
        rangeSelector: {
          selected: 12,
        },
        colors: Homechart.colors,
        yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
            text: "Total %",
          },
          labels: {
            align: "left",
            x: 15,
            y: -15,
          },
        },
        tooltip: {
          formatter: function () {
            var d = new Date(this.x);
            var s = d.toDateString() + "<br>";
            $.each(this.points, function (i, point) {
              s += "<br>" + point.series.name + ": " + point.y + "%" + "</br>";
            });
            return s;
          },
        },
        legend: {
          enabled: true,
        },
        exporting: {
          enabled: false,
        },
        plotOptions: {
          area: {
            stacking: "percent",
            lineColor: "#ffffff",
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: "#ffffff",
            },
          },
        },

        series: seriesOptionsA,
      });
    }, 0);

    //////////////////
    // Style Pie Chart
    //////////////////

    let styleChart = [];
    let assetClassChart = [];
    let styleTbl = [];

    let lastDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
      scn_port,
    ]);
    lastDate = lastDate.length ? lastDate[0].dt : "";

    let lastStyleData = alasql(
      "SELECT DISTINCT style FROM ? WHERE dt = '" + lastDate + "'",
      [scn_port]
    );
    let lastAssetClassData = alasql(
      "SELECT DISTINCT fund_asset_class_focus FROM ? WHERE dt = '" +
        lastDate +
        "'",
      [scn_port]
    );

    let lastTimestamp = parseInt(moment(lastDate, "YYYY-MM-DD").format("x"));

    for (let i in lastStyleData) {
      let line = lastStyleData[i];

      let sum = alasql(
        "SELECT SUM(CAST(allocation as FLOAT)) as allocation FROM ? WHERE dt = '" +
          lastDate +
          "' AND style = '" +
          line.style +
          "'",
        [scn_port]
      );

      styleChart.push({
        name: line.style,
        y: sum[0].allocation,
        dt: lastTimestamp,
      });

      let allocations = alasql(
        "SELECT `fund_name`, `allocation` FROM ? WHERE dt = '" +
          lastDate +
          "' AND style = '" +
          line.style +
          "'",
        [scn_port]
      );

      for (let k in allocations) {
        let all = allocations[k];
        styleTbl.push([all.fund_name, all.allocation + "%"]);
      }
    }

    for (let i in lastAssetClassData) {
      let line = lastAssetClassData[i];

      let sum = alasql(
        "SELECT SUM(CAST(allocation as FLOAT)) as allocation FROM ? WHERE dt = '" +
          lastDate +
          "' AND fund_asset_class_focus = '" +
          line.fund_asset_class_focus +
          "'",
        [scn_port]
      );

      assetClassChart.push({
        name: line.fund_asset_class_focus,
        y: sum[0].allocation,
        dt: lastTimestamp,
      });
    }

    setTimeout(() => {
      $(stylePieSelector).highcharts({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        tooltip: {
          formatter: function () {
            let { point } = this;
            let d = new Date(point.dt);
            let string =
              d.toDateString() +
              "<br>" +
              point.name +
              ": <b>" +
              point.percentage +
              "%</b>";
            return string;
          },
        },
        title: {
          text: "",
        },
        exporting: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            //colors: Homechart.colors,
            dataLabels: {
              enabled: true,
              format: "<br>{point.percentage:.1f} %",
              distance: -50,
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
            },
            showInLegend: true,
          },
        },
        series: [
          {
            data: styleChart,
          },
        ],
      });

      $(assetPieSelector).highcharts({
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        tooltip: {
          formatter: function () {
            let { point } = this;
            let d = new Date(point.dt);
            let string =
              d.toDateString() +
              "<br>" +
              point.name +
              ": <b>" +
              point.percentage +
              "%</b>";
            return string;
          },
        },
        title: {
          text: "",
        },
        exporting: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            //colors: Homechart.colors,
            dataLabels: {
              enabled: true,
              format: "<br>{point.percentage:.1f} %",
              distance: -50,
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
            },
            showInLegend: true,
          },
        },
        series: [
          {
            data: assetClassChart,
          },
        ],
      });
    }, 0);

    return {
      styles: styleTbl,
      lastA: moment(lastTimestamp, "x").format("MMM DD YYYY"),
      lastB: moment(lastTimestamp, "x").format("MMM DD YYYY"),
    };
  },
  renderAssetStyleStockChartTable(dat) {
    let dates = [];
    let styles = [];
    let ASTC = [];

    var fund_name = "";
    $.each(dat.getPortfolioVami, function (key, val) {
      fund_name = val.scenario_name;
      return false;
    });

    var bm_name = "";
    $.each(dat.getBenchmarkVami, function (key, val) {
      bm_name = val.benchmark_name;
      return false;
    });

    var arc_name = "";
    $.each(dat.getARCVami, function (key, val) {
      arc_name = val.benchmark_name;
      return false;
    });

    /***BAR CHART****/

    var scn_port = dat.getPortfolioData;

    $.each(scn_port, function (k, v) {
      if (dates.indexOf(v.dt) == -1) {
        dates.push(v.dt);
      }

      if (styles.indexOf(v.style) == -1) {
        styles.push(v.style);
      }

      if (ASTC.indexOf(v.fund_asset_class_focus) == -1) {
        ASTC.push(v.fund_asset_class_focus);
      }
    });

    var seriesOptions = [];
    $.each(styles, function (k, v) {
      var sdata = Calc.getDataForstac(dates, v, scn_port);
      seriesOptions.push({
        name: v,
        data: sdata,
      });
    });

    var seriesOptionsA = [];
    $.each(ASTC, function (k, v) {
      var sdata = Calc.getDataForstacA(dates, v, scn_port);
      seriesOptionsA.push({
        name: v,
        data: sdata,
      });
    });
    return { seriesOptions, seriesOptionsA };
  },

  renderConservativeFundChart: (selector, graph) => {
    var fund_data = [];
    $.each(graph, function (key, val) {
      fund_data.push(parseFloat([val.funds]));
    });

    var bm_data = [];
    $.each(graph, function (key, val) {
      bm_data.push(parseFloat([val.benchmark]));
    });

    setTimeout(() => {
      $(selector).highcharts({
        chart: {
          type: "column",
        },
        colors: ["#434348", "#7cb5ec"],
        credits: { enabled: false },
        title: { text: "" },
        xAxis: {
          categories: [
            "<-5%",
            "-5% to -4 %",
            "-4% to -3 %",
            "-3% to -2%",
            "-2% to -1%",
            "-1% to 0%",
            "0% to 1%",
            "1% to 2%",
            "2% to 3%",
            "3% to 4%",
            "4% to 5%",
            "5%>",
          ],
          crosshair: true,
          labels: {
            rotation: 300,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Distribution",
          },
        },
        series: [
          {
            name: "Fund",
            data: fund_data,
          },
          {
            name: "Benchmark",
            data: bm_data,
          },
        ],
      });
    }, 0);
  },

  renderConservativeReturnChart: (selector, graph) => {
    var chart_data = [];
    $.each(graph, function (key, val) {
      chart_data.push(parseFloat([val.funds]));
    });

    setTimeout(() => {
      $(selector).highcharts({
        chart: {
          type: "column",
        },
        colors: ["#434348", "#7cb5ec"],
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: [
            "<-5%",
            "-5% to -4%",
            "-4% to -3%",
            "-3% to -2%",
            "-2% to -1%",
            "-1% to 0%",
            "0% to 1%",
            "1% to 2%",
            "2% to 3%",
            "3% to 4%",
            "4% to 5%",
            "5%>",
          ],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Distribution",
          },
        },

        series: [
          {
            name: "Fund",
            data: chart_data,
          },
        ],
      });
    }, 0);
  },

  renderAnnualizedBacktestChart: (selector, graph, client_data) => {
    let categories = [];
    let fund_data = [];
    let bm_data = [];

    let client_cat = [];
    let client_benchmark = [];
    let client_fund = [];

    for (let i in graph) {
      let line = graph[i];
      let year = parseInt(line.metric_name);
      let fd = parseFloat((parseFloat(line.fund_return) * 100).toFixed(2));
      let bm = parseFloat((parseFloat(line.bm_return) * 100).toFixed(2));

      switch (line.metric_name) {
        case "1 Year":
          if (categories.indexOf("1 Year") == -1) categories.push("1 Year");
          fund_data.push(fd);
          bm_data.push(bm);
          break;
        case "3 Year":
          if (categories.indexOf("3 Year") == -1) categories.push("3 Year");
          fund_data.push(fd);
          bm_data.push(bm);
          break;
        case "5 Year":
          if (categories.indexOf("5 Year") == -1) categories.push("5 Year");
          fund_data.push(fd);
          bm_data.push(bm);
          break;
        case "Since Inception":
          if (categories.indexOf("Since Inception") == -1)
            categories.push("Since Backtest Start Date");
          fund_data.push(fd);
          bm_data.push(bm);
          break;
      }
    }
    if (client_data && client_data.length > 0) {
      for (let i in client_data) {
        let line = client_data[i];
        // let year = parseInt(line.metric_name)
        let fd = parseFloat((parseFloat(line.fund_return) * 100).toFixed(2));
        let bm = parseFloat((parseFloat(line.bm_return) * 100).toFixed(2));

        switch (line.metric_name) {
          case "1 Year":
            if (client_cat.indexOf("1 Year") == -1) client_cat.push("1 Year");
            client_benchmark.push(bm);
            client_fund.push(fd);
            break;
          case "3 Year":
            if (client_cat.indexOf("3 Year") == -1) client_cat.push("3 Year");
            client_benchmark.push(bm);
            client_fund.push(fd);
            break;
          case "5 Year":
            if (client_cat.indexOf("5 Year") == -1) client_cat.push("5 Year");
            client_benchmark.push(bm);
            client_fund.push(fd);
            break;
          case "Since Inception":
            if (client_cat.indexOf("Since Inception") == -1)
              client_cat.push("Since Inception");
            client_benchmark.push(bm);
            client_fund.push(fd);
            break;
        }
      }
    }

    $(selector).highcharts({
      chart: {
        type: "column",
      },
      colors: ["#434348", "#7cb5ec"],
      title: { text: "" },
      credits: { enabled: false },
      xAxis: {
        categories: categories,
        crosshair: true,
      },
      tooltip: {
        formatter: function () {
          return (
            "<b>" +
            this.x +
            "</b><br/>" +
            this.series.name +
            ": " +
            this.y +
            "%<br/>"
          );
        },
      },
      yAxis: {
        title: {},
      },

      series: [
        {
          name: "Model Portfolio",
          data: fund_data,
        },
        {
          name: "Benchmark *",
          data: bm_data,
        },
      ],
    });

    let cats = [{ title: " " }];
    fund_data = fund_data.map((a) => a + "%");
    bm_data = bm_data.map((a) => a + "%");
    client_benchmark = client_benchmark.map((e) => e + "%");
    client_fund = client_fund.map((e) => e + "%");

    categories.filter((title) =>
      cats.push({ title: title.toString(), sTitle: title.toString() })
    );

    fund_data.unshift("Model Portfolio");
    bm_data.unshift("Benchmark *");
    client_benchmark.unshift("Benchmark");
    client_fund.unshift("orig portfolio");

    return { cats, fund_data, bm_data, client_benchmark, client_fund };
  },

  renderCalendarBacktestChart: (selector, graph) => {
    let categories = [];

    let all_values = [];

    let fund_data = [];
    let bm_data = [];

    for (let i in graph) {
      let line = graph[i];
      let year = parseInt(line.metric_name);

      if (year <= 2017 && year >= 2012) {
        all_values.push({
          category: year,
          fund_data: parseFloat([line.fund_return]),
          bm_data: parseFloat([line.bm_return]),
        });
      }
    }

    // Sorting
    all_values.sort((a, b) => parseInt(b.category) - parseInt(a.category));

    for (let i in all_values) {
      categories.push(all_values[i].category);
      fund_data.push(
        parseFloat((parseFloat([all_values[i].fund_data]) * 100).toFixed(2))
      );
      bm_data.push(
        parseFloat((parseFloat([all_values[i].bm_data]) * 100).toFixed(2))
      );
    }

    $(selector).highcharts({
      chart: {
        type: "column",
      },
      colors: ["#434348", "#7cb5ec"],
      title: { text: "" },
      credits: { enabled: false },
      xAxis: {
        categories: categories,
        crosshair: true,
      },
      tooltip: {
        formatter: function () {
          return (
            "<b>" +
            this.x +
            "</b><br/>" +
            this.series.name +
            ": " +
            this.y +
            "%<br/>"
          );
        },
      },
      yAxis: {
        title: {},
      },

      series: [
        {
          name: "Model Portfolio",
          data: fund_data,
        },
        {
          name: "Benchmark *",
          data: bm_data,
        },
      ],
    });

    let cats = [{ title: " " }];
    fund_data = fund_data.map((a) => a + "%");
    bm_data = bm_data.map((a) => a + "%");
    categories.filter((title) =>
      cats.push({ title: title.toString(), sTitle: title.toString() })
    );

    fund_data.unshift("Model Portfolio");
    bm_data.unshift("Benchmark *");

    return { cats, fund_data, bm_data };
  },

  renderPerformance(data) {
    let cols = [{ title: "" }];
    let rows = [];
    let bm = ["Benchmark"];
    let fd = ["Portfolio"];
    let queue = ["1 Month", "3 Month", "YTD", "Since Inception"];
    let q = ["1 Month*", "3 Month**", "YTD", "Since Inception"];

    let sorted_data = [];

    let d = alasql(
      "SELECT metric_name FROM ? ORDER BY metric_name DESC LIMIT 1",
      [data]
    );

    data.map((row) => {
      if (queue.indexOf(row.metric_name) > -1) {
        if (row.metric_name.toLowerCase() == "1 month")
          row.metric_name = "1 Month*";
        else if (row.metric_name.toLowerCase() == "3 month")
          row.metric_name = "3 Month**";
        sorted_data[q.indexOf(row.metric_name)] = row;
      }
    });

    for (let i = 0; i < sorted_data.length; i++) {
      let line = sorted_data[i];
      if (!line) {
        cols.push({
          title: q[i],
        });

        bm.push("n/a");
        fd.push("n/a");

        continue;
      }

      if (cols.indexOf(line.metric_name) == -1) {
        cols.push({
          title: line.metric_name,
        });

        bm.push((parseFloat(line.bm_return) * 100).toFixed(2) + "%");
        fd.push((parseFloat(line.fund_return) * 100).toFixed(2) + "%");
      }
    }

    return [cols, [fd, bm]];
  },

  renderPerformanceGraph(selector, data) {
    let cats = [];
    let sorted_data = [];
    let fund = [];
    let bm = [];

    data.map((row) => {
      if (
        row.metric_name == "1 Month*" ||
        row.metric_name == "3 Month**" ||
        row.metric_name == "YTD" ||
        row.metric_name == "Since Inception"
      ) {
        sorted_data.push(row);
      }
    });

    sorted_data.sort((a, b) => {
      if (a.metric_name < b.metric_name) return -1;
      if (a.metric_name > b.metric_name) return 1;
      return 0;
    });

    for (let i in sorted_data) {
      let line = sorted_data[i];

      cats.push(line.metric_name);

      fund.push(parseFloat((parseFloat(line.fund_return) * 100).toFixed(2)));
      bm.push(parseFloat((parseFloat(line.bm_return) * 100).toFixed(2)));
    }

    setTimeout(() => {
      $(selector).highcharts({
        colors: ["#434348", "#7cb5ec"],
        chart: {
          type: "column",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: cats,
        },
        yAxis: {
          allowDecimals: false,
          title: {
            text: "Porfolio/Benchmark(%)",
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.x +
              "</b><br/>" +
              this.series.name +
              ": " +
              this.y +
              "%<br/>"
            );
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        legend: {
          enabled: true,
          labelFormatter: function () {
            var words = this.name.split(/[\s]+/);
            var numWordsPerLine = 5;
            var str = [];
            for (var word in words) {
              if (word > 0 && word % numWordsPerLine === 0) str.push("<br>");
              str.push(words[word]);
            }
            return str.join(" ");
          },
        },
        series: [
          {
            name: "Portfolio",
            data: fund,
          },
          {
            name: "Benchmark",
            data: bm,
          },
        ],
      });
    }, 0);
  },

  renderComparePortfolioTables(live, current) {
    let lastLiveDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
      live,
    ]);
    let lastCurrDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
      current,
    ]);

    let lastLivePort = alasql(
      "SELECT * FROM ? WHERE dt = '" + lastLiveDate[0].dt + "'",
      [live]
    );
    let lastCurrPort = alasql(
      "SELECT * FROM ? WHERE dt = '" + lastCurrDate[0].dt + "'",
      [current]
    );

    let distinct = alasql("SELECT DISTINCT symbol FROM ?", [
      [...live, ...current],
    ]);

    let cols = [];

    for (let i in distinct) {
      let line = distinct[i];
      let ac = "";
      let symbol = "";
      let liveW = "";
      let currW = "";

      let live = alasql(
        "SELECT * FROM ? WHERE symbol = '" + line.symbol + "'",
        [lastLivePort]
      );
      let curr = alasql(
        "SELECT * FROM ? WHERE symbol = '" + line.symbol + "'",
        [lastCurrPort]
      );

      if (live.length) {
        ac = live[0].fund_asset_class_focus;
        symbol = live[0].symbol;
        liveW = live[0].allocation + "%";
      }

      if (curr.length) {
        ac = !ac.length ? curr[0].fund_asset_class_focus : ac;
        symbol = !symbol.length ? curr[0].symbol : symbol;
        currW = curr[0].allocation + "%";
      }

      if (live.length || curr.length)
        cols.push([ac, symbol, liveW || "", currW || ""]);
    }

    return { cols, liveDate: lastLiveDate[0].dt, currDate: lastCurrDate[0].dt };
  },

  renderRiskStatistics(data) {
    let cols = [
      { title: " " },
      { title: "Portfolio" },
      { title: "Benchmark *" },
    ];
    let rows = [];
    for (let i in data) {
      let line = data[i];
      let perc = "";
      let gen = 1;
      let metric_name = line.metric_name.toLowerCase();
      if (metric_name == "up" || metric_name == "down") {
        continue;
      }
      if (
        metric_name !== "correlation" &&
        metric_name !== "beta" &&
        metric_name !== "sharpe ratio" &&
        metric_name !== "sortino ratio" &&
        metric_name !== "down months"
      ) {
        perc = "%";
      }
      if (
        metric_name == "alpha" ||
        metric_name == "annualized return" ||
        metric_name == "annualized vol" ||
        metric_name == "downside deviation"
      ) {
        gen = 100;
      }
      let fund = 0;
      let benchmark = 0;

      if (!line.fund || (line.fund * gen).toFixed(2) == 0.0) fund = "";
      else fund = (line.fund * gen).toFixed(2) + perc;

      if (!line.benchmark || (line.benchmark * gen).toFixed(2) == 0.0)
        benchmark = "";
      else benchmark = (line.benchmark * gen).toFixed(2) + perc;

      rows.push([line.metric_name, fund, benchmark]);
    }

    return [cols, rows, false, false];
  },

  renderScatterChart(selector, data) {
    $(selector).highcharts({
      chart: {
        type: "scatter",
        zoomType: "xy",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        title: {
          enabled: true,
          text: "Index",
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true,
      },
      yAxis: {
        title: {
          text: "Value",
        },
      },
      legend: {
        layout: "vertical",
        align: "left",
        verticalAlign: "top",
        x: 100,
        y: 70,
        floating: true,
        borderWidth: 1,
      },
      // plotOptions: {
      // 	scatter: {
      // 		marker: {
      // 			radius: 5,
      // 			states: {
      // 				hover: {
      // 					enabled: true,
      // 					lineColor: 'rgb(100,100,100)'
      // 				}
      // 			}
      // 		},
      // 		states: {
      // 			hover: {
      // 				marker: {
      // 					enabled: false
      // 				}
      // 			}
      // 		},
      // 		tooltip: {
      // 			headerFormat: '<b>{series.name}</b><br>',
      // 			pointFormat: '{point.x} cm, {point.y} kg'
      // 		}
      // 	}
      // },
      series: [
        {
          color: "rgba(223, 83, 83, .5)",
          data,
        },
      ],
    });
  },
};

export default Homechart;



// WEBPACK FOOTER //
// ./src/helper/homechart.helper.js